import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Switch } from '../ui/switch';
import {
  Sheet, SheetContent, SheetHeader, SheetTitle,
} from '../ui/sheet';
import { FloppyDisk } from '@phosphor-icons/react';
import { Loader2 } from 'lucide-react';

export function AdminPlanEditor({ editPlan, setEditPlan, saving, onSave }) {
  return (
    <Sheet open={!!editPlan} onOpenChange={(o) => { if (!o) setEditPlan(null); }}>
      <SheetContent className="w-full sm:max-w-md" aria-describedby="edit-plan-desc">
        <SheetHeader>
          <SheetTitle>Modifiér le plan</SheetTitle>
          <p id="edit-plan-desc" className="text-sm text-[#4B5563]">Ajustez le prix et les parametres</p>
        </SheetHeader>
        {editPlan && (
          <div className="space-y-5 mt-6">
            <div>
              <Label>Nom du plan</Label>
              <Input value={editPlan.name} onChange={e => setEditPlan({...editPlan, name: e.target.value})}
                className="mt-1 h-12" data-testid="edit-plan-name" />
            </div>
            <div>
              <Label>Prix (EUR)</Label>
              <Input type="number" step="0.01" value={editPlan.price}
                onChange={e => setEditPlan({...editPlan, price: e.target.value})}
                className="mt-1 h-12" data-testid="edit-plan-price" />
            </div>
            <div>
              <Label>Description</Label>
              <Input value={editPlan.description || ''}
                onChange={e => setEditPlan({...editPlan, description: e.target.value})}
                className="mt-1 h-12" data-testid="edit-plan-desc-input" />
            </div>
            <div>
              <Label>Jours d'essai gratuit</Label>
              <Input type="number" value={editPlan.trial_days || 7}
                onChange={e => setEditPlan({...editPlan, trial_days: e.target.value})}
                className="mt-1 h-12" data-testid="edit-plan-trial" />
            </div>
            <div className="flex items-center justify-between">
              <Label>Plan actif</Label>
              <Switch checked={editPlan.is_active}
                onCheckedChange={v => setEditPlan({...editPlan, is_active: v})}
                data-testid="edit-plan-active" />
            </div>
            <Button onClick={onSave} disabled={saving}
              className="w-full h-12 bg-[#FF6B00] hover:bg-orange-700" data-testid="save-plan-btn">
              {saving ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <FloppyDisk size={20} className="mr-2" />}
              Enregistrér
            </Button>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
